import { email, mailtoHref, phoneDisplay, telHref, whatsappUrl } from "../common";

const Contact = () => {
  return (
    <div className="page">
      <section className="section">
        <h1>Get in touch</h1>
        <p className="section-text">
          Questions about workshops, school collaborations, or enrollment? Reach
          out on WhatsApp or email — we will get back to you as soon as we can.
        </p>
      </section>

      <div className="contact-wrapper">
        <div className="contact-card contact-card--wide">
          <div className="contact-item">
            <span className="icon" aria-hidden>
              💬
            </span>
            <div>
              <h3>WhatsApp</h3>
              <p>
                <a href={whatsappUrl} target="_blank" rel="noreferrer">
                  {phoneDisplay}
                </a>
              </p>
            </div>
          </div>

          <div className="contact-item">
            <span className="icon" aria-hidden>
              📞
            </span>
            <div>
              <h3>Phone</h3>
              <p>
                <a href={telHref}>{phoneDisplay}</a>
              </p>
            </div>
          </div>

          <div className="contact-item">
            <span className="icon" aria-hidden>
              📧
            </span>
            <div>
              <h3>Email</h3>
              <p>
                <a href={mailtoHref}>{email}</a>
              </p>
            </div>
          </div>

          <div className="contact-item contact-b2b">
            <span className="icon" aria-hidden>
              🏫
            </span>
            <div>
              <h3>Schools &amp; B2B</h3>
              <p>
                DM us on WhatsApp or email to collaborate — curriculum support, lab
                programs, and batches for students.
              </p>
            </div>
          </div>

          <div className="contact-item">
            <span className="icon" aria-hidden>
              📍
            </span>
            <div>
              <h3>Address</h3>
              <div className="contact-address">
                <p>Mejaroad, Meja, Prayagraj</p>
                <p>Uttar Pradesh — 212303</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
